import React from 'react';
import ExportHeader from './ExportHeader';
import ExportFooter from './ExportFooter';
import ExportBody from './ExportBody';
import { getClassNames } from './ExportUtils';
import './scss/export-page.scss';

const ExportPage = ({
  children,
  email = '',
  footer = false,
  header = true,
  label = '',
  page = 0,
  totalPages = 0,
  overflow = false
}) => {
  const classes = getClassNames(['pdf-layout__page', overflow && 'pdf-layout__page--overflow']);

  return (
    <section className={classes}>
      {header && <ExportHeader label={label} />}
      <ExportBody
        footerSpacer={footer}
        isOverflow={overflow}
        header={<ExportHeader label={label} />}
      >
        {children}
      </ExportBody>
      {footer && <ExportFooter page={page} totalPages={totalPages} email={email} />}
    </section>
  );
};

ExportPage.defaultProps = {
  footer: true,
  header: true,
  overflow: false
};

export default ExportPage;
